import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import type {RootState} from './store';
import {employeesigninApiCall} from '../api/employeesignin-api';
import {employeeSigninRequest, employeeSigninResponse} from '../lib/types';
//import axios from 'axios';

const employeeSignInData = {
  statusCode: '',
  statusMessage: '',
  data: {
    userId: '',
    fName: '',
    lName: '',
    email: '',
    contactNo: '',
    stroreId: '',
    stroreName: '',
    role: '',
    pwdChgReq: '',
    status: '',
    ouCode: '',
  },
};

interface employeeSigninState {
  employeeData: employeeSigninResponse;
  loading: boolean;
  error: string;
}

// Define the initial state using that type
const initialState: employeeSigninState = {
  employeeData: employeeSignInData,
  loading: false,
  error: '',
};

export const signInEmployee = createAsyncThunk(
  'employee/employeesignin',
  async (parameters: employeeSigninRequest, thunkApi) => {
    return employeesigninApiCall(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const employeeSignInSlice = createSlice({
  name: 'employeesignin',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(signInEmployee.pending, state => {
      state.loading = true;
    });
    builder.addCase(signInEmployee.fulfilled, (state, action) => {
      state.loading = false;
      state.employeeData = action.payload;
    });
    builder.addCase(signInEmployee.rejected, (state, action) => {
      state.error = action.toString();

      state.loading = false;
    });
  },
});

//Other code such as selectors can use the imported `RootState` type
export const {resetState} = employeeSignInSlice.actions;

export const employeeAllData = (state: RootState): employeeSigninResponse =>
  state.employeeSignInReducer.employeeData;
export const errorData = (state: RootState): string =>
  state.employeeSignInReducer.error;
export const loading = (state: RootState): boolean =>
  state.employeeSignInReducer.loading;

export default employeeSignInSlice.reducer;
